export default __webpack_public_path__ + "images/LA.b464bd1.png";